<template>
    <section>
        <v-btn @click="OpenAddCoursePricing">Add Pricing</v-btn>
        <app-add-course-pricing ref="CoursePricing" :dialog='AddCoursePricing' @close='CloseDialog'></app-add-course-pricing>
        <app-pricing-table></app-pricing-table>
    </section>    
</template>
<script>
import appAddCoursePricing from '../views/dialogs/AddCoursePricing'
import appPricingTable     from '../views/tables/PricingTable'
export default {
    components:{

        appAddCoursePricing,
        appPricingTable
    },
    data(){
        return {

            AddCoursePricing : false,

        }
    },
    methods:{
        OpenAddCoursePricing(){

            this.$refs.CoursePricing.GetCourseListFromDB()
            this.AddCoursePricing = true
        },
        CloseDialog(){

            this.AddCoursePricing = false
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style scoped>

</style>